import React from 'react';
import styled from 'styled-components';
import {
    AppBar,
    Box,
    Grid,
    ListItemIcon,
    ListItemIconProps,
    ListItemText,
    Backdrop as MuiBackdrop,
    Drawer as MuiDrawer,
    DrawerProps as MuiDrawerProps,
    Theme,
} from '@material-ui/core';
import { Activatable, Padded, WithOpened } from './types';

export const GridElement = styled(Grid)`
    height: 100%;
    flex-grow: 1;
`;

export const MainElement = styled.main<Padded>`
    width: 100%;
    display: flex;
    background-color:  ${props => props.theme.palette.background.default};
    overflow: hidden;
    ${({ theme, padding }) => `
        min-height: calc(100vh - ${theme.toolbar.desktopHeight}px);
        ${padding ? `padding: 0 0 0 ${theme.appDrawer.collapsedWidth}px;` : ``}
    `};
`;

export const StyledListItemIcon = styled(({ isActive, ...props }: ListItemIconProps & Activatable) => (
    <ListItemIcon {...props} />
))`
    display: flex;
    justify-content: center;
    ${({ theme, isActive }) => `
        width: ${ theme.appDrawer.collapsedWidth}px;
        && {
            color: ${ isActive ? theme.palette.common.white : theme.appDrawer.textColor};
        }
    `}
`;

export const StyledListItemIcons = styled(ListItemIcon) <ListItemIconProps & Activatable>`
    display: flex;
    justify-content: center;
    ${({ theme, isActive }) => `
        width: ${ theme.appDrawer.collapsedWidth}px;
        && {
            color: ${ isActive ? theme.palette.common.white : theme.appDrawer.textColor};
        }
    `}
`;

export const StyledListItemText = styled(ListItemText)`
    ${({ theme }) => `
        color: ${theme.palette.common.white};
    `}
`;

export const CloseSection = styled(Box)`
    ${({ theme }) => `
        background-color: ${theme.palette.primary.main};
        padding: 0 ${theme.spacing(2)}px;
        color: ${theme.palette.common.white};
    `}
`;

export const StyledAppBar = styled(AppBar)`
     ${({ theme }) => `
        && {
            background-color: ${theme.palette.common.white};
            box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
        }
    `}
`;


interface DrawerProps extends MuiDrawerProps {
    open?: boolean;
}

const transitionCss = (theme: Theme) => theme.transitions.create(['width', 'padding', 'left', 'right'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
});

export const Drawer = styled(({ open, ...props }: DrawerProps) => (<MuiDrawer {...props} />))`
    flex-shrink: 0;
    overflow-x: hidden;
    white-space: nowrap;
    position: absolute;
    ${({ theme, open }) => `
        & .MuiDrawer-paper {
            background-color: ${theme.appDrawer.backgroundColor};
            transition: ${transitionCss(theme)};
            margin-top: ${theme.toolbar.mobileHeight}px;
            color: ${theme.appDrawer.textColor};
            width: ${theme.appDrawer.width}px;
            overflow-x: hidden;
            ${theme.direction === 'ltr' ? `left: -${theme.appDrawer.width}px;` : `right: ${theme.appDrawer.width}px;`}
            ${open
        ? `${theme.direction === 'ltr' ? `left: 0;` : `right: 0`}`
        : `${theme.direction === 'ltr' ? `left: -${theme.appDrawer.width}px;` : `right: ${theme.appDrawer.width}px;`}`
}
            ${theme.breakpoints.up('sm')} {
                margin-top: ${theme.toolbar.desktopHeight}px;
            }
            ${theme.breakpoints.up('md')} {
                margin-top: ${theme.toolbar.desktopHeight}px;
                ${theme.direction === 'ltr' ? `left: 0;` : `right: 0;`}
                width: ${open ? theme.appDrawer.width : theme.appDrawer.collapsedWidth}px;
            }
        }
    `}
`;

export const Backdrop = styled(MuiBackdrop)`
        && {
            ${({ theme }) => `
                z-index: ${theme.zIndex.drawer - 1};
            `}
        }
`;

export const MenuButtonContiner = styled.div<WithOpened>`
    ${({ theme, opened }) => `
        padding: ${theme.spacing(0, 1)};
        margin-left: ${theme.spacing(-2)}px;
        margin-right: ${theme.spacing(2)}px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-self: stretch;
        ${theme.breakpoints.up('sm')} {
            margin-left: ${theme.spacing(-3)}px;
            margin-right: ${theme.spacing(3)}px;
        }
        ${theme.breakpoints.up('md')} {
            padding-left: ${theme.spacing(2)}px;
            padding-right: ${opened ? theme.spacing(24.5) : theme.spacing(2)}px;
            transition: ${transitionCss(theme)};
        }
        background-color: ${theme.palette.primary.main};
        color: ${theme.palette.common.white};
    `}
`;
